import { useQuery } from '@tanstack/react-query';
import { NewsService } from '@/services/news/newsService';
import { GetAllNewsParams } from '@/types/news';

export const useNews = (params?: GetAllNewsParams) => {
  // Get all news query (public use only - only visible news)
  const newsQuery = useQuery({
    queryKey: ['news', params],
    queryFn: async () => {
      if (!params) return [];
      return NewsService.getAllNews(params);
    },
    enabled: !!params,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: false, // Don't refetch on window focus (only on mount)
    retry: (failureCount, error: any) => {
      // Don't retry on 401 errors (authentication issues)
      if (error?.status === 401) {
        return false;
      }
      // Retry up to 2 times for other errors
      return failureCount < 2;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
  });

  return {
    // Data
    news: newsQuery.data || [],
    
    // Loading states
    isLoading: newsQuery.isLoading,
    
    // Error states
    error: newsQuery.error?.message || null,
    
    // Refetch function
    refetchNews: newsQuery.refetch,
  };
};
